import { InfoIcon, List } from "../../../../api/components";
import * as React from 'react';
export default {
  InfoIcon,
  List,
  React
};